module.exports = __webpack_public_path__ + "static/media/icon-excel.f61c9efc.svg";